const state = {
    name : window.APPDATA.name,
    os : window.APPDATA.os,
    is_app : window.APPDATA.is_app,
    debug : window.APPDATA.debug,
    images : window.APPDATA.images,
    placeholder : {
        normal : '',
    },
    urls : window.APPDATA.urls,
    breadcrumbs : [],
    page : {
        type : '',
        title : '',
        description : '',
    },
    google : {
        recaptcha_site_key : window.APPDATA.google_recaptcha_site_key,
    },
    ads: {
        google_header_top: window.APPDATA.ads.google_header_top,
        linkwise_top: window.APPDATA.ads.linkwise_top,
        linkwise_bottom: window.APPDATA.ads.linkwise_bottom,
        linkwise_exam_bottom: window.APPDATA.ads.linkwise_exam_bottom,
        linkwise_exam_message: window.APPDATA.ads.linkwise_exam_message,
    },
};

const getters = {

};

export default {
    state,
    getters,
}
